// OPS Occult Library comparative visual archive v5 — Aeromancy source pack.
(()=>{
  const TITLE='aeromancy';
  const SOURCES=[
    {
      date:'c. 1070 (depicting the comet of 1066)',
      period:'11th-century medieval',
      creator:'Unknown Bayeux Tapestry embroiderers; photograph by Myrabella',
      work:'Bayeux Tapestry — scene 32, men observing Halley’s Comet',
      page:'Scene 32; comet passage associated with the Latin inscription ISTI MIRANT STELLA',
      institution:'Bayeux Tapestry Museum / Bayeux Museum, Bayeux, France',
      collection:'Bayeux Tapestry',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Bayeux_Tapestry_scene32_Halley_comet.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Bayeux_Tapestry_scene32_Halley_comet.jpg',
      rights:'Historical artwork public domain; Myrabella’s faithful digital reproduction released under CC0 1.0',
      rightsUrl:'https://creativecommons.org/publicdomain/zero/1.0/',
      attribution:'Bayeux Tapestry, scene 32, c. 1070, depicting Halley’s Comet as seen in 1066; photograph by Myrabella. Public-domain artwork / CC0 digital reproduction via Wikimedia Commons.',
      medium:'Embroidered narrative textile',
      technique:'Embroidery in wool yarn on linen',
      material:'Wool yarn on linen support',
      colour:'Polychrome embroidery on undyed linen; colour photograph',
      visualCharacter:'The comet is rendered as a compact flame-like stitched form above a row of upward-pointing figures. Flat coloured thread, strong contour and the horizontal narrative register make the sky sign part of the same material surface as bodies, lettering and architecture.',
      note:'A medieval sky sign is made narratively visible: several figures point upwards at the comet while the surrounding story treats the apparition as charged with consequence. It is useful comparative material for aeromancy because the sky is read as message rather than background.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'1555',
      period:'Mid-16th-century Renaissance',
      creator:'Olaus Magnus (1490–1557)',
      work:'On Suddenly Appearing Rings and about the Effects of Comets',
      page:'Book I woodcut; exact page is not stated on the Commons record',
      institution:'Historical print; digitised reproduction hosted by Wikimedia Commons',
      collection:'Olaus Magnus, Historia de gentibus septentrionalibus, Book I, Rome, 1555',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Olaus_Magnus_-_On_Suddenly_Appearing_Rings_and_about_the_Effects_of_Comets.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Olaus_Magnus_-_On_Suddenly_Appearing_Rings_and_about_the_Effects_of_Comets.jpg',
      rights:'Public domain; Commons identifies the 1555 historical work as free of known copyright restrictions',
      rightsUrl:'https://commons.wikimedia.org/wiki/File:Olaus_Magnus_-_On_Suddenly_Appearing_Rings_and_about_the_Effects_of_Comets.jpg#Licensing',
      attribution:'Olaus Magnus, On Suddenly Appearing Rings and about the Effects of Comets, Historia de gentibus septentrionalibus, Book I, 1555. Public domain via Wikimedia Commons.',
      medium:'Printed natural-history woodcut',
      technique:'Relief woodcut printing',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visualCharacter:'Bold carved outlines divide the sky into rings, rays and a comet while small figures and buildings below supply scale and consequence. Dense black marks and simplified forms favour immediate legibility at book-page size.',
      note:'The woodcut combines parhelia with a comet and depicts harmful consequences below. The archive uses it as evidence of an early-modern visual grammar in which unusual atmospheric and celestial phenomena were recorded together with interpreted effects, not as proof that every halo was formally classed as aeromancy.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'1557 (illustrating a reported comet of 1340)',
      period:'Mid-16th-century prodigy chronicle',
      creator:'Conrad Lycosthenes (1518–1561); Wellcome Collection reproduction',
      work:'Comet seen in the sky: 1340 and plague at Florence, from Prodigiorum ac ostentorum chronicon',
      page:'Printed-text illustration; Wellcome image L0005342',
      institution:'Wellcome Collection, London',
      collection:'Conrad Lycosthenes, Prodigiorum ac ostentorum chronicon, 1557; Wellcome image L0005342',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/C._Lycosthenes%2C_1340_comet_in_sky_and_plague_at_Florence_Wellcome_L0005342.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:C._Lycosthenes%2C_1340_comet_in_sky_and_plague_at_Florence_Wellcome_L0005342.jpg',
      rights:'Creative Commons Attribution 4.0 International (CC BY 4.0)',
      rightsUrl:'https://creativecommons.org/licenses/by/4.0/',
      attribution:'Conrad Lycosthenes, comet over Florence / plague narrative, Prodigiorum ac ostentorum chronicon, 1557. Wellcome Collection, image L0005342. CC BY 4.0.',
      medium:'Prodigy-chronicle book illustration',
      technique:'Printed woodcut / relief illustration',
      material:'Printing ink on paper',
      colour:'Monochrome historical print; digitised reproduction',
      visualCharacter:'A large radiating comet dominates the upper field while compact urban and human forms occupy the lower register. Heavy contour and sparse tonal cutting create a blunt visual link between celestial phenomenon and the terrestrial episode recorded beside it.',
      note:'Lycosthenes’ prodigy chronicle places a reported comet and a plague narrative in the same visual record. The important research point is the historical association of extraordinary sky events with terrestrial calamity; the archive does not present the comet as a medical cause of plague.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'1886 engraving (depicting an observation of 1 February 1882)',
      period:'Late-19th-century scientific observation',
      creator:'Unknown expedition illustrator / engraver; NOAA historical archive reproduction',
      work:'Lunar halo at Fort Conger, north-western Greenland',
      page:'Engraving documenting the 1 February 1882 observation at Fort Conger',
      institution:'NOAA historical image archive',
      collection:'Fort Conger / Lady Franklin Bay expedition atmospheric-observation record',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Lunar_Halo_at_Fort_Conger_February_1_1882.jpg?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Lunar_Halo_at_Fort_Conger_February_1_1882.jpg',
      rights:'Public domain; Commons identifies the NOAA-source image as PD-USGov-NOAA / PD-old',
      rightsUrl:'https://commons.wikimedia.org/wiki/File:Lunar_Halo_at_Fort_Conger_February_1_1882.jpg#Licensing',
      attribution:'Lunar Halo at Fort Conger, observation of 1 February 1882, engraving published 1886. NOAA historical image archive; public domain via Wikimedia Commons.',
      medium:'Scientific expedition engraving',
      technique:'Printed engraving after an observational drawing',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visualCharacter:'Fine tonal hatching describes a dark polar sky, low horizon and luminous concentric halo around the Moon. The composition is observational and spatially measured in character, contrasting with the emblematic compression of the earlier omen and prodigy images.',
      note:'This is deliberately a comparison point rather than an aeromantic source. By the late nineteenth century a spectacular ring around the Moon can be preserved as a measured expedition observation, showing how the same class of strange sky image could move from omen/prodigy culture into meteorological documentation.',
      verifiedOn:'2026-09-13'
    }
  ];

  const key=(value)=>String(value||'').trim().toLowerCase();
  const nudgeRenderer=()=>{
    const target=document.querySelector('[data-library-reader]');
    if(!target) return;
    const marker=document.createComment('ops-visual-archive-v5-ready');
    target.appendChild(marker);
    marker.remove();
  };
  const install=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    const entry=pack.entries.find((item)=>key(item&&item.title)===TITLE);
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    nudgeRenderer();
    return true;
  };
  if(!install()) document.addEventListener('DOMContentLoaded',install,{once:true});
})();
